import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Col, Row, Select } from 'antd';
import * as routes from 'constants/routeNames';
import { useNavigate } from 'react-router-dom';
import {
  componentsTypes,
  catalogsTypes,
  TIPO_HALLAZGO_SELECTOR,
  FECHAS_CAT_SELECTOR,
  MEDIDAS_CAT_SELECTOR,
  TIPOS_MI_SELECTOR
} from 'constants/configuracionTiposCatalogos';
import './CatalogSelector.scss';
import { useForm } from 'antd/es/form/Form';

export const CatalogSelector = ({
  opcionesCatalogo,
  initialValues,
  setSeleccionComponente,
  setIsSameComponent
}) => {
  const [catalogOption, setCatalogOption] = useState(opcionesCatalogo);
  const { Option } = Select;
  const [form] = useForm();
  const navigate = useNavigate();

  // Agrega el catálogo correspondiente a la elección del componente
  const handleCatalogChange = (value) => {
    if (typeof setSeleccionComponente === 'function') {
      setSeleccionComponente(value);
    }
    if (value === 1) setCatalogOption(catalogsTypes.Espectaculares);
    if (value === 2) setCatalogOption(catalogsTypes.MediosImpresos);
    if (initialValues?.tipoCatalogo !== undefined) {
      form.setFieldsValue({ tipoCatalogo: null });
      setIsSameComponent(false);
    }
  };

  const handleOptionChange = (value) => {
    if (value === TIPO_HALLAZGO_SELECTOR) navigate(routes.CATALOGO_TIPO_HALLAZGOS_ROUTE);
    if (value === FECHAS_CAT_SELECTOR) navigate(routes.CATALOGO_FECHAS_ROUTE);
    if (value === MEDIDAS_CAT_SELECTOR) navigate(routes.CATALOGO_MEDIOS_IMPRESOS_ROUTE);
    if (value === TIPOS_MI_SELECTOR) navigate(routes.CATALOGO_TIPO_MEDIOS_IMPRESOS_ROUTE);
    if (typeof setIsSameComponent === 'function') setIsSameComponent(true);
  };

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  return (
    <div className="catalog-select-container">
      <Col xs={24} sm={12} md={8} lg={6}>
        <Form form={form} initialValues={initialValues}>
          <Row gutter={64}>
            <Col xs={6}>
              <div className="form-label">
                <span>*</span>Monitoreo:
              </div>
              <Form.Item
                name="componente"
                required
                rules={[{ required: true, message: 'El campo es requerido' }]}>
                <Select
                  placeholder="Selecciona"
                  style={{ minWidth: '200px', maxWidth: '300px' }}
                  // style={{ width: '300px', minWidth: '100px', maxWidth: '400px' }}
                  onChange={handleCatalogChange}>
                  {componentsTypes.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {catalogOption && (
              <Col xs={24} sm={12} md={8} lg={6}>
                <div className="form-label">
                  <span>*</span>Tipo de catálogo:
                </div>
                <Form.Item
                  required
                  name="tipoCatalogo"
                  rules={[{ required: true, message: 'El campo es requerido' }]}>
                  <Select
                    placeholder="Selecciona"
                    style={{ minWidth: '200px', maxWidth: '250px' }}
                    // style={{ width: '300px', minWidth: '100px', maxWidth: '400px' }}
                    onChange={handleOptionChange}>
                    {catalogOption &&
                      catalogOption.map((option) => (
                        <Option key={option.value} value={option.value}>
                          {option.label}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            )}
          </Row>
        </Form>
      </Col>
    </div>
  );
};

CatalogSelector.propTypes = {
  initialValues: PropTypes.shape({
    componente: PropTypes.number,
    tipoCatalogo: PropTypes.number
  }),
  opcionesCatalogo: PropTypes.arrayOf(
    PropTypes.shape({
      Espectaculares: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.number.isRequired,
          label: PropTypes.string.isRequired
        })
      ).isRequired,
      MediosImpresos: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.number.isRequired,
          label: PropTypes.string.isRequired
        })
      ).isRequired
    })
  ),
  setSeleccionComponente: PropTypes.func.isRequired,
  setIsSameComponent: PropTypes.func.isRequired
};

CatalogSelector.defaultProps = {
  initialValues: undefined,
  opcionesCatalogo: undefined
};
